<div class="d-flex gap-10 container">
  @if (data.icon) {
  <mat-icon [svgIcon]="data.icon">data.icon</mat-icon>
  } @else { @switch (data.type) { @case ('success') {
  <mat-icon>check_circle_outline</mat-icon>
  } @case ('danger') {
  <mat-icon>info</mat-icon>
  } } }
  <div class="d-flex flex-column gap-5">
    @if (data.title) {
    <div class="title">{{ data.title }}</div>
    } @if (data.message) {
    <div class="message">{{ data.message }}</div>
    }
  </div>
</div>
